import { Button, EButtonColor } from '@web_opxp/components';
import { LanguageSelectors, useTranslation } from '@web_opxp/features';
import { Lottie } from '@web_opxp/lottie';
import React from 'react';
import { connect } from 'react-redux';
import { SKELETON_CLASSNAME, SKELETON_DUMMYTEXT } from '../../base/constants';
import { SessionSelectors } from '../../session';
import { IState } from '../../store/state';
import { ledIncreaseDifficultyLottie } from '../constants';
import { getWorkoutId } from '../selectors';
import { ExerciseActions } from '../slice';

export interface IIncreaseDifficultyViewProps {
  exerciseId: string;
  loading: boolean;
  onAnswer: (answer: boolean) => void;
}

export const IncreaseDifficultyViewFC: React.FC<IIncreaseDifficultyViewProps> = ({ exerciseId, loading, onAnswer }) => {
  const { t } = useTranslation();

  const exercise = loading ? SKELETON_DUMMYTEXT : t(`common.exercises:Title.${exerciseId}`);
  const title = loading ? SKELETON_DUMMYTEXT : t('LED.IncreaseDifficulty.Title');
  const description = loading ? SKELETON_DUMMYTEXT : t('LED.IncreaseDifficulty.Description', { exercise });
  const skeletonClass = loading ? SKELETON_CLASSNAME : '';
  const disagreeButtonLabel = loading ? SKELETON_DUMMYTEXT : t('LED.IncreaseDifficulty.Keep');
  const agreeButtonLabel = loading ? SKELETON_DUMMYTEXT : t('LED.IncreaseDifficulty.Change');
  return (
    <div className="led-view increase-difficulty">
      <Lottie.Component.LottieAnimation
        name={ledIncreaseDifficultyLottie}
        autoplay={true}
        loop={true}
        className="led-lottie"
      />
      <div className="led-info">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="led-actions">
          <Button
            className={skeletonClass}
            label={disagreeButtonLabel}
            color={EButtonColor.white}
            onClick={() => onAnswer(false)}
          />
          <Button
            className={skeletonClass}
            label={agreeButtonLabel}
            color={EButtonColor.white}
            onClick={() => onAnswer(true)}
          />
        </div>
      </div>
    </div>
  );
};

export const mapStateToProps = (state: IState) => {
  const workoutId = getWorkoutId(state);
  const exerciseId = SessionSelectors.getExerciseName(state, workoutId) ?? '';
  const loading = LanguageSelectors.isLoading(state);
  return {
    exerciseId,
    loading,
  };
};

export const mapDispatchToProps = {
  onAnswer: ExerciseActions.difficultyIncreaseAnswer,
};

const IncreaseDifficultyView = connect(mapStateToProps, mapDispatchToProps)(IncreaseDifficultyViewFC);
export default IncreaseDifficultyView;
